import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import createDebounce from 'redux-debounced';
import checkoutAccordionReducer from '../reducers/checkoutAccordionReducer';

const configureStore = (railsProps) => (
  createStore(checkoutAccordionReducer, railsProps, applyMiddleware(createDebounce(), thunk))
);

export default configureStore;
